import { render } from "./DefIndexTitle.vue?vue&type=template&id=d0ab7890&scoped=true"
import script from "./DefIndexTitle.vue?vue&type=script&lang=js"
export * from "./DefIndexTitle.vue?vue&type=script&lang=js"

import "./DefIndexTitle.vue?vue&type=style&index=0&id=d0ab7890&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0ab7890"]])

export default __exports__